export const MAX_FORM_FILE_UPLOAD_SIZE_IN_MB = 10;

const ALLOWED_TYPES = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/pdf',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/zip',
    'application/x-zip-compressed',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation'
];

const ALLOWED_EXTENSIONS = [
    'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'heic', 'heif', 'tif', 'tiff',
    'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'zip'
];

const extensionOf = (name) => {
    const match = /\.([a-z0-9]+)$/i.exec(String(name ?? ''));
    return match ? match[1].toLowerCase() : '';
};

/**
 * Whether a file may be attached. A phone often hands over a photo from its gallery or a cloud
 * drive with no type, and sometimes with no extension on its name. Such a file is accepted rather
 * than turned away in silence (AD-2360). A file whose type or extension says it is something else,
 * such as a video, is refused.
 */
export const isAllowedFile = (file) => {
    const type = String(file?.type ?? '').toLowerCase();
    const extension = extensionOf(file?.name);

    if (type.startsWith('image/') || ALLOWED_TYPES.includes(type)) {
        return true;
    }

    if (ALLOWED_EXTENSIONS.includes(extension)) {
        return true;
    }

    return type === '' || type === 'application/octet-stream' ? extension === '' : false;
};

export const rejectionMessage = (rejections) => {
    const codes = rejections.flatMap(rejection => rejection.errors.map(error => error.code));

    if (codes.includes('file-too-large')) {
        return `The file is larger than ${MAX_FORM_FILE_UPLOAD_SIZE_IN_MB} MB. Choose a smaller file.`;
    }

    return 'That type of file cannot be attached. Choose a photo, a PDF, or a Word, Excel or PowerPoint file.';
};
